import dayJs from 'dayjs'
import { qiniuImageURLPrefix, shopDefault } from "@/config/qiniu"

function transformShopType(shopType) {
  let types = {
    wsc: '微商城',
    ph: '连锁采配',
    pf: '档口批发',
    old_ls: '老零售',
    new_ls: '门店零售'
  }
  return types[shopType]
}

function formatCnTime(time) {
  const target = dayJs(time)
  const now = dayJs()
  const diffValue = now.diff(target)
  if (diffValue < 1000 * 60) { // 小于一分钟
      return '刚刚'
  } else if (diffValue >= 1000 * 60 && diffValue < 1000 * 60 * 60) { // 大于一分钟小于一小时
      return parseInt(diffValue / (1000 * 60)) + '分钟前'
  } else if (target.isBefore(now, 'year')) { // 今年以前
      return dayJs(target).format('YYYY年MM月DD日 HH:mm:ss')
  } else if (target.isBefore(now.subtract(1, 'day'), 'day')) { // 昨天以前 今年以内
      return dayJs(target).format('MM月DD日 HH:mm:ss')
  } else if (target.isBefore(now, 'day')) { // 昨天
      return dayJs(target).format('昨天 HH:mm:ss')
  } else if (diffValue >= 1000 * 60 * 60) { // 大于60分钟
      return dayJs(target).format('HH:mm:ss')
  }
}

 const changeImgUrl = (value) => {
		if(!value) return value
		// 兼容旧版static开头的图片地址
		if(!value || value.indexOf('static') > -1) {
			value = shopDefault
		}
		if (!value.startsWith('http')) {
			// 七牛云的图片加上域名前缀
			value = qiniuImageURLPrefix + value
		}
		
		return value
}

export default {
  transformShopType,
	formatCnTime,
	changeImgUrl
}